import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import Link from "src/components/routing/Link";
import {
    TrialInstitutionLaboratoryBreadcrumbs,
    TrialInstitutionLaboratoryCreateBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import useNavigate from "src/hooks/useNavigate";
import { ITrialInstitutionLaboratoryReduxFormState } from "src/reducers/reactReduxForms/trialInstitutionLaboratory";
import * as InstitutionLaboratoryActions from "../../../actions/institutionLaboratory";
import * as NavigationActions from "../../../actions/navigation";
import * as TrialInstitutionActions from "../../../actions/trialInstitution";
import * as TrialInstitutionLaboratoryActions from "../../../actions/trialInstitutionLaboratory";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    DatePickerFormInputFabric,
    SelectFormInput,
} from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import { TrialInstitutionLabSubMenu } from "../../../helpers/subMenuHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";

import "./TrialInstitutionLaboratoryPage.scss";

interface TrialInstitutionLaboratoryPageProps {
    form: Dtos.TrialInstitutionLaboratory & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITrialInstitutionLaboratoryReduxFormState;
    trialInstitutionLaboratory: Dtos.TrialInstitutionLaboratory;
    lookups: Dtos.Lookup[];
    loadingTrialInstitutionLaboratory: boolean;
    loadTrialInstitutionLaboratorySuccess: boolean;
    loadTrialInstitutionLaboratoryFailure: boolean;
    loadTrialInstitutionLaboratoryErrorCode: string;
    savingTrialInstitutionLaboratory: boolean;
    saveTrialInstitutionLaboratorySuccess: boolean;
    saveTrialInstitutionLaboratoryFailure: boolean;
    creatingTrialInstitutionLaboratory: boolean;
    createTrialInstitutionLaboratorySuccess: boolean;
    createTrialInstitutionLaboratoryFailure: boolean;
    validatingTrialInstitutionLaboratory: boolean;
    validationFailures: Dtos.ResponseError[];
    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    trialInstitution: Dtos.TrialInstitution;
    loadingTrialInstitution: boolean;
    loadTrialInstitutionSuccess: boolean;
    loadTrialInstitutionFailure: boolean;
    loadTrialInstitutionErrorCode: string;
    institutionLaboratories: Dtos.InstitutionLaboratory[];
    loadingInstitutionLaboratories: boolean;
    loadInstitutionLaboratoriesSuccess: boolean;
    loadInstitutionLaboratoriesFailure: boolean;
    loadInstitutionLaboratoriesErrorCode: string;
    clearTrialInstitutionLaboratory: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoryClearActionCreator;
    loadTrialInstitutionLaboratory: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoryLoadByIdActionCreator;
    saveTrialInstitutionLaboratory: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratorySaveActionCreator;
    createTrialInstitutionLaboratory: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoryCreateActionCreator;
    validateTrialInstitutionLaboratory: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoryValidateActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
    loadInstitutionLaboratories: InstitutionLaboratoryActions.IInstitutionLaboratoryLoadByInstitutionIdActionCreator;
    clearInstitutionLaboratories: InstitutionLaboratoryActions.IInstitutionLaboratoryClearActionCreator;
    loadTrialInstitution: TrialInstitutionActions.ITrialInstitutionLoadByIdActionCreator;
    clearTrialInstitution: TrialInstitutionActions.ITrialInstitutionClearActionCreator;
}

const reduxFormName: string = "reduxForms.trialInstitutionLaboratory";

const TrialInstitutionLaboratoryPage: FC<
    TrialInstitutionLaboratoryPageProps
> = ({
    form,
    formState,
    formProperties,
    trialInstitutionLaboratory,
    lookups,
    loadingTrialInstitutionLaboratory,
    loadTrialInstitutionLaboratoryFailure,
    loadTrialInstitutionLaboratoryErrorCode,
    savingTrialInstitutionLaboratory,
    saveTrialInstitutionLaboratorySuccess,
    saveTrialInstitutionLaboratoryFailure,
    creatingTrialInstitutionLaboratory,
    validatingTrialInstitutionLaboratory,
    validationFailures,
    permissions,
    institutionLaboratories,
    loadingInstitutionLaboratories,
    trialInstitution,
    loadingTrialInstitution,
    loadTrialInstitutionFailure,
    loadTrialInstitutionErrorCode,
    loadInstitutionLaboratoriesFailure,
    loadInstitutionLaboratoriesErrorCode,
    clearTrialInstitutionLaboratory,
    loadTrialInstitutionLaboratory,
    saveTrialInstitutionLaboratory,
    createTrialInstitutionLaboratory,
    validateTrialInstitutionLaboratory,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems,
    loadInstitutionLaboratories,
    clearInstitutionLaboratories,
    loadTrialInstitution,
    clearTrialInstitution
}) => {
    //
    // -- Params --
    const { trialId } = useParams<{ trialId: string }>();
    const { trialInstitutionId } = useParams<{ trialInstitutionId: string }>();
    const { trialInstitutionLaboratoryId } = useParams<{
        trialInstitutionLaboratoryId: string;
    }>();
    const trialIdNumber = parseInt(trialId, 10);
    const trialInstitutionIdNumber = parseInt(trialInstitutionId, 10);
    const trialInstitutionLaboratoryIdNumber = parseInt(
        trialInstitutionLaboratoryId,
        10
    );

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [init, setInit] = useState<boolean>(false);
    const [formInitalised, setFormInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    //
    // -- Hooks --
    const navigate = useNavigate();


    // Load Trial Institution Laboratory & Trial Institution
    useEffect(() => {
        if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionLaboratoryIdNumber &&
            !trialInstitutionLaboratory &&
            !loadingTrialInstitutionLaboratory
        ) {
            setBreadcrumbs(
                TrialInstitutionLaboratoryBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber
                )
            );

            loadTrialInstitutionLaboratory(trialInstitutionLaboratoryIdNumber);
        } else if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            !trialInstitutionLaboratoryIdNumber &&
            !trialInstitutionLaboratory
        ) {
            setBreadcrumbs(
                TrialInstitutionLaboratoryCreateBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber
                )
            );
            setDrawerItems([]);
            createTrialInstitutionLaboratory(null, trialInstitutionIdNumber);
        } else if (trialInstitutionLaboratory && !formInitalised) {
            loadReduxForm();
            setFormInitalised(true);
        }

        if (trialInstitutionIdNumber && !trialInstitution && !loadingTrialInstitution) {
            loadTrialInstitution(trialInstitutionIdNumber);
        }
    }, [
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionLaboratoryIdNumber,
        trialInstitutionLaboratory,
        permissions,
        formInitalised,
        setDrawerItems,
        setBreadcrumbs,
        loadTrialInstitutionLaboratory,
        trialInstitution,
        loadTrialInstitution,
        setFormInitalised,
        loadingTrialInstitution,
        loadingTrialInstitutionLaboratory
    ]);

    // Load Institution Laboratories
    useEffect(() => {
        if (trialInstitution && !init) {
            loadInstitutionLaboratories(trialInstitution?.institutionId);
            setInit(true);
        }
    }, [
        trialInstitutionLaboratory,
        institutionLaboratories,
        loadInstitutionLaboratories,
        init,
        setInit,
        trialInstitution
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadTrialInstitutionLaboratoryFailure) {
            navigate(`/error/${loadTrialInstitutionLaboratoryErrorCode}`);
        }
        if (loadTrialInstitutionFailure) {
            navigate(`/error/${loadTrialInstitutionErrorCode}`);
        }
        if (loadInstitutionLaboratoriesFailure) {
            navigate(`/error/${loadInstitutionLaboratoriesErrorCode}`);
        }
    }, [
        loadTrialInstitutionLaboratoryFailure,
        loadTrialInstitutionLaboratoryErrorCode,
        loadTrialInstitutionFailure,
        loadTrialInstitutionErrorCode,
        loadInstitutionLaboratoriesFailure,
        loadInstitutionLaboratoriesErrorCode,
        navigate,
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionLaboratoryIdNumber &&
            trialInstitutionLaboratory?.trialInstitution &&
            trialInstitutionLaboratory?.laboratory
        ) {
            setDrawerItems(
                TrialInstitutionLabSubMenu(
                    trialInstitutionLaboratory,
                    permissions
                )
            );
            setBreadcrumbs(
                TrialInstitutionLaboratoryBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber,
                    trialInstitutionLaboratory.trialInstitution?.trial
                        ?.displayName,
                    trialInstitutionLaboratory.trialInstitution?.institution
                        ?.name,
                    trialInstitutionLaboratory.laboratory?.name
                )
            );
        } else if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            !trialInstitutionLaboratoryIdNumber &&
            trialInstitution
        ) {
            setBreadcrumbs(
                TrialInstitutionLaboratoryCreateBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitution?.trial?.displayName,
                    trialInstitution?.institution?.name
                )
            );
        }
    }, [
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionLaboratoryIdNumber,
        trialInstitutionLaboratory,
        trialInstitution,
        setDrawerItems,
        setBreadcrumbs,
        TrialInstitutionLaboratoryBreadcrumbs,
        TrialInstitutionLaboratoryCreateBreadcrumbs,
        TrialInstitutionLabSubMenu,
    ]);

    // Reload trial institution laboratory after saving
    useEffect(() => {
        if (
            !savingTrialInstitutionLaboratory &&
            saveTrialInstitutionLaboratorySuccess
        ) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Trial Institution Laboratory saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(
                    `/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/labs`
                );
            } else if (!trialInstitutionLaboratoryIdNumber) {
                navigate(
                    `/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/labs/${trialInstitutionLaboratory?.id}/details`
                );
                clearTrialInstitutionLaboratory();
            } else {
                loadTrialInstitutionLaboratory(trialInstitutionLaboratoryIdNumber);
            }
        }
    }, [
        savingTrialInstitutionLaboratory,
        saveTrialInstitutionLaboratorySuccess,
        loadTrialInstitutionLaboratory,
        trialInstitutionLaboratoryIdNumber,
        navigate,
        saveAndReturn,
        clearTrialInstitutionLaboratory,
    ]);

    // Failed saving
    useEffect(() => {
        if (
            !savingTrialInstitutionLaboratory &&
            saveTrialInstitutionLaboratoryFailure
        ) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [
        savingTrialInstitutionLaboratory,
        saveTrialInstitutionLaboratorySuccess,
        loadTrialInstitutionLaboratory,
        trialInstitutionLaboratoryIdNumber,
    ]);

    // Cleanup effect to clear the trial institution laboratory on component unmount
    useEffect(() => {
        return () => {
            clearTrialInstitutionLaboratory();
            clearTrialInstitution();
            clearInstitutionLaboratories();
            resetForm(reduxFormName);
        };
    }, [
        clearTrialInstitutionLaboratory,
        clearTrialInstitution,
        clearInstitutionLaboratories,
        resetForm,
        reduxFormName,
    ]);

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.TrialInstitutionLaboratory =
                {} as Dtos.TrialInstitutionLaboratory;

            if (!data.trialInstitutionId) {
                changes.trialInstitutionId = trialInstitutionIdNumber;
            }

            await saveTrialInstitutionLaboratory(
                Object.assign({ ...data }, changes)
            );

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    const handleOnSubmitFailed = (_data: Dtos.TrialInstitutionLaboratory) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const onCancel = () => {
        navigate(
            `/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/labs`
        );
    };

    const loadReduxForm = () => {
        let extraData: Dtos.TrialInstitutionLaboratory =
            {} as Dtos.TrialInstitutionLaboratory;

        loadForm(
            reduxFormName,
            Object.assign({ ...trialInstitutionLaboratory }, extraData)
        );
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.TrialInstitutionLaboratory =
                {} as Dtos.TrialInstitutionLaboratory;

            if (
                form &&
                hasBeenSubmitted &&
                !validatingTrialInstitutionLaboratory
            ) {
                await validateTrialInstitutionLaboratory(
                    Object.assign({ ...form }, changes)
                );
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const renderContent = useMemo(() => {
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermissionFor(
                undefined,
                trialInstitutionLaboratoryIdNumber,
                permissions,
                Dtos.Permission.TrialInstitutionLabUpdate,
                Dtos.Permission.TrialInstitutionLabCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingTrialInstitutionLaboratory ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        const currentInstituionLaboratoryIds = institutionLaboratories?.map(
            (x) => x.laboratoryId
        );
        const currentTrialInstitutionLaboratoryIds =
            trialInstitution?.laboratories?.map((x) => x.laboratoryId);
        let options = currentInstituionLaboratoryIds?.filter(
            (x) => !currentTrialInstitutionLaboratoryIds?.includes(x)
        );

        if (options && trialInstitutionLaboratory?.laboratoryId) {
            options.push(trialInstitutionLaboratory.laboratoryId);
        }

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <div className="card card-shadow" style={{ zIndex: 1 }}>
                            <div className="form-row py-4 px-4 align-items-center">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratory",
                                        {
                                            laboratoryId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled:
                                                    formDisabled ||
                                                    loadingTrialInstitution ||
                                                    loadingInstitutionLaboratories,
                                                inputProps: {
                                                    loading:
                                                        loadingTrialInstitution ||
                                                        loadingInstitutionLaboratories,
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "trialInstitutionLaboratory",
                                                                "laboratoryId",
                                                                lookups
                                                            ),
                                                            form.laboratoryId
                                                        )?.filter((x) =>
                                                            options?.includes(
                                                                x.value
                                                            )
                                                        ),
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-1 d-flex justify-content-end">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratory",
                                        {
                                            active: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: CheckboxFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    label: "Active, ",
                                                },
                                                inputLabel: " ",
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-5 d-none",
                                                fieldClassName:
                                                    "col-sm-12 generic-form-field d-flex",
                                                changeAction: (
                                                    _model,
                                                    value,
                                                    _form,
                                                    _parentModel
                                                ) => {
                                                    if (value) {
                                                        changeForm(
                                                            reduxFormName +
                                                                ".dateCeased",
                                                            null
                                                        );
                                                    }
                                                    changeForm(
                                                        reduxFormName +
                                                            ".active",
                                                        value
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-5">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratory",
                                        {
                                            dateCeased: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled:
                                                    formDisabled || form.active,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-sm-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Details</h1>
                    </div>
                    <div
                        className="col d-flex justify-content-end align-items-stretch"
                        style={{ height: "38px" }}
                    >
                        {AuthenticationHelper.hasPermission(
                            permissions,
                            Dtos.Permission.LabView
                        ) && trialInstitutionLaboratoryIdNumber ? (
                            <Link
                                className={"btn btn-primary"}
                                url={`/labs/${trialInstitutionLaboratory?.laboratoryId}/details`}
                                target="_blank"
                            >
                                {`Primary  `}
                                <FontAwesomeIcon
                                    icon={
                                        FontAwesomeIcons.Duotone
                                            .ARROWUPRIGHTFROMSQUARE
                                    }
                                />
                            </Link>
                        ) : null}
                    </div>
                </div>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => handleOnSubmit(val)}
                    onSubmitFailed={(val) => handleOnSubmitFailed(val)}
                >
                    {renderFormControls(
                        form,
                        "trialInstitutionLaboratory",
                        formComponents,
                        lookups,
                        validationFailures,
                        formProperties,
                        changeForm
                    )}
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    false
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    true
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={onCancel}
                            className="btn btn-primary mr-2"
                        >
                            Cancel
                        </button>
                    </div>
                </Form>
            </>
        );
    }, [
        AuthenticationHelper,
        trialInstitutionLaboratoryIdNumber,
        permissions,
        savingTrialInstitutionLaboratory,
        formState,
        handleOnSubmit,
        handleOnSubmitFailed,
        renderFormControls,
        lookups,
        validationFailures,
        formProperties,
        form,
        changeForm,
        reduxFormName,
        onCancel,
        institutionLaboratories,
        trialInstitution,
        trialInstitutionLaboratory,
    ]);

    return (
        <RestrictedLayout
            permission={Dtos.Permission.TrialInstitutionLabView}
            loading={
                loadingTrialInstitutionLaboratory ||
                creatingTrialInstitutionLaboratory ||
                savingTrialInstitutionLaboratory ||
                loadingTrialInstitution ||
                loadingInstitutionLaboratories
            }
        >
            {renderContent}
        </RestrictedLayout>
    );
};

const mapStateToProps = (
    state: ITmdState
): Partial<TrialInstitutionLaboratoryPageProps> => {
    let trialInstitutionLaboratory:
        | Dtos.TrialInstitutionLaboratory
        | undefined = !(
        state.trialInstitutionLaboratory.formData instanceof Array
    )
        ? state.trialInstitutionLaboratory.formData
        : undefined;
    let trialInstitution: Dtos.TrialInstitution | undefined = !(
        state.trialInstitution.formData instanceof Array
    )
        ? state.trialInstitution.formData
        : undefined;
    let institutionLaboratories: Dtos.InstitutionLaboratory[] | undefined =
        state.institutionLaboratory.formData instanceof Array
            ? state.institutionLaboratory.formData
            : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        trialInstitutionLaboratory: trialInstitutionLaboratory!,
        loadingTrialInstitutionLaboratory:
            state.trialInstitutionLaboratory.loadState &&
            state.trialInstitutionLaboratory.loadState.status ==
                RequestState.Pending,
        loadTrialInstitutionLaboratorySuccess:
            state.trialInstitutionLaboratory.loadState &&
            state.trialInstitutionLaboratory.loadState.status ==
                RequestState.Success,
        loadTrialInstitutionLaboratoryFailure:
            state.trialInstitutionLaboratory.loadState &&
            state.trialInstitutionLaboratory.loadState.status ==
                RequestState.Failure,
        loadTrialInstitutionLaboratoryErrorCode:
            state.trialInstitutionLaboratory.loadState.errorCode,
        savingTrialInstitutionLaboratory:
            state.trialInstitutionLaboratory.saveState &&
            state.trialInstitutionLaboratory.saveState.status ==
                RequestState.Pending,
        saveTrialInstitutionLaboratorySuccess:
            state.trialInstitutionLaboratory.saveState &&
            state.trialInstitutionLaboratory.saveState.status ==
                RequestState.Success,
        saveTrialInstitutionLaboratoryFailure:
            state.trialInstitutionLaboratory.saveState &&
            state.trialInstitutionLaboratory.saveState.status ==
                RequestState.Failure,
        creatingTrialInstitutionLaboratory:
            state.trialInstitutionLaboratory.createState &&
            state.trialInstitutionLaboratory.createState.status ==
                RequestState.Pending,
        createTrialInstitutionLaboratorySuccess:
            state.trialInstitutionLaboratory.createState &&
            state.trialInstitutionLaboratory.createState.status ==
                RequestState.Success,
        createTrialInstitutionLaboratoryFailure:
            state.trialInstitutionLaboratory.createState &&
            state.trialInstitutionLaboratory.createState.status ==
                RequestState.Failure,
        validatingTrialInstitutionLaboratory:
            state.trialInstitutionLaboratory.validateState &&
            state.trialInstitutionLaboratory.validateState.status ==
                RequestState.Pending,
        user: state.user.data,
        permissions: permissions,
        lookups: state.trialInstitutionLaboratory.lookups,
        form: state.reduxForms.trialInstitutionLaboratory,
        formState: state.trialInstitutionLaboratory.formState,
        formProperties: state.trialInstitutionLaboratory.formProperties,
        reduxFormState: state.reduxForms.formState.trialInstitutionLaboratory,
        validationFailures: trialInstitutionLaboratory
            ? state.trialInstitutionLaboratory.validationFailures
            : undefined,
        institutionLaboratories: institutionLaboratories!,
        loadingInstitutionLaboratories:
            state.institutionLaboratory.loadState &&
            state.institutionLaboratory.loadState.status ==
                RequestState.Pending,
        loadInstitutionLaboratoriesSuccess:
            state.institutionLaboratory.loadState &&
            state.institutionLaboratory.loadState.status ==
                RequestState.Success,
        loadInstitutionLaboratoriesFailure:
            state.institutionLaboratory.loadState &&
            state.institutionLaboratory.loadState.status ==
                RequestState.Failure,
        loadInstitutionLaboratoriesErrorCode:
            state.institutionLaboratory.loadState.errorCode,
        trialInstitution: trialInstitution!,
        loadingTrialInstitution:
            state.trialInstitution.loadState &&
            state.trialInstitution.loadState.status == RequestState.Pending,
        loadTrialInstitutionSuccess:
            state.trialInstitution.loadState &&
            state.trialInstitution.loadState.status == RequestState.Success,
        loadTrialInstitutionFailure:
            state.trialInstitution.loadState &&
            state.trialInstitution.loadState.status == RequestState.Failure,
        loadTrialInstitutionErrorCode:
            state.trialInstitution.loadState.errorCode,
    };
};

const mapDispatchToProps = (
    dispatch
): Partial<TrialInstitutionLaboratoryPageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),
        loadTrialInstitutionLaboratory: bindActionCreators(
            TrialInstitutionLaboratoryActions.LoadTrialInstitutionLaboratoryById,
            dispatch
        ),
        clearTrialInstitutionLaboratory: bindActionCreators(
            TrialInstitutionLaboratoryActions.Clear,
            dispatch
        ),
        saveTrialInstitutionLaboratory: bindActionCreators(
            TrialInstitutionLaboratoryActions.SaveTrialInstitutionLaboratory,
            dispatch
        ),
        createTrialInstitutionLaboratory: bindActionCreators(
            TrialInstitutionLaboratoryActions.CreateTrialInstitutionLaboratory,
            dispatch
        ),
        validateTrialInstitutionLaboratory: bindActionCreators(
            TrialInstitutionLaboratoryActions.ValidateTrialInstitutionLaboratory,
            dispatch
        ),
        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        ),
        loadInstitutionLaboratories: bindActionCreators(
            InstitutionLaboratoryActions.LoadInstitutionLaboratoryByInstitutionId,
            dispatch
        ),
        clearInstitutionLaboratories: bindActionCreators(
            InstitutionLaboratoryActions.Clear,
            dispatch
        ),
        loadTrialInstitution: bindActionCreators(
            TrialInstitutionActions.LoadTrialInstitutionById,
            dispatch
        ),
        clearTrialInstitution: bindActionCreators(
            TrialInstitutionActions.Clear,
            dispatch
        )
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrialInstitutionLaboratoryPage);
